class OrganizationSwitch {
    static channelName = 'snapaddy-organization-switch';
    static titlePrefix = '🔔 ';
    channel = null;
    tabId = null;
    pendingAlert = false;
    // Broadcast an org switch event to other tabs
    broadcast(source, organizationId) {
        const channel = this.getOrCreateChannel();
        if (!channel) {
            return;
        }
        channel.postMessage({
            type: 'organization-switched',
            source: source,
            organizationId: organizationId ?? undefined,
            sourceTabId: this.getOrCreateTabId(),
        });
    }
    // Initialize the window helper and register listeners once per tab
    register() {
        if (typeof window === 'undefined') {
            return;
        }
        const typedWindow = window;
        if (!typedWindow.snapaddyOrgaSwitch) {
            typedWindow.snapaddyOrgaSwitch = {
                broadcast: (source, organizationId) => this.broadcast(source, organizationId),
                listen: (handler) => this.listen(handler),
            };
        }
        if (typedWindow.__snapaddyOrgaSwitchListener) {
            return;
        }
        typedWindow.__snapaddyOrgaSwitchListener = true;
        this.listen(this.handleIncomingSwitch);
        this.registerVisibilityListeners();
    }
    // Listen for channel messages and ignore self-sent events
    listen(handler) {
        const channel = this.getOrCreateChannel();
        if (!channel) {
            return;
        }
        const tabId = this.getOrCreateTabId();
        channel.onmessage = (event) => {
            if (event?.data?.type === 'organization-switched' && event?.data?.sourceTabId !== tabId) {
                handler();
            }
        };
    }
    // Create a stable per-tab id for message filtering
    getOrCreateTabId() {
        if (this.tabId) {
            return this.tabId;
        }
        this.tabId = `${Date.now()}-${Math.random()}`;
        return this.tabId;
    }
    // Create the BroadcastChannel if supported
    getOrCreateChannel() {
        if (this.channel) {
            return this.channel;
        }
        if (typeof window === 'undefined' || !('BroadcastChannel' in window)) {
            return null;
        }
        this.channel = new BroadcastChannel(OrganizationSwitch.channelName);
        return this.channel;
    }
    // Handle an incoming switch event, deferring when hidden
    handleIncomingSwitch = () => {
        // Alerts may be suppressed by the browser when the tab is not active
        // Thus, we defer the alert until the user returns to the tab
        if (document.hidden) {
            this.pendingAlert = true;
            if (!document.title.startsWith(OrganizationSwitch.titlePrefix)) {
                document.title = `${OrganizationSwitch.titlePrefix}${document.title}`;
            }
            return;
        }
        this.showAlertAndReload();
    };
    // Register focus/visibility listeners for deferred alerts
    registerVisibilityListeners() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('focus', this.handleVisibilityChange);
        window.addEventListener('pageshow', this.handleVisibilityChange);
    }
    // Trigger deferred alert when the tab becomes active
    handleVisibilityChange = () => {
        if (!document.hidden && this.pendingAlert) {
            this.pendingAlert = false;
            this.showAlertAndReload();
        }
    };
    // Show alert, then reload the page
    showAlertAndReload() {
        if (document.title.startsWith(OrganizationSwitch.titlePrefix)) {
            document.title = document.title.slice(OrganizationSwitch.titlePrefix.length);
        }
        alert('You have switched the organization!\n' +
            'This view is obsolete. Please note all the changes, because this page is about to be reloaded.');
        window.location.reload();
    }
}
const organizationSwitch = new OrganizationSwitch();
export function broadcastOrganizationSwitch(source, organizationId) {
    organizationSwitch.broadcast(source, organizationId);
}
export function registerOrganizationSwitch() {
    organizationSwitch.register();
}
